// DPR-aware canvas surface. All draw calls are in CSS pixels.

export type Surface = {
  el: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  width: number;
  height: number;
  dpr: number;
  clear(bg: string): void;
  resize(cssWidth: number, cssHeight: number): void;
};

export function createSurface(canvas: HTMLCanvasElement): Surface {
  const ctx = canvas.getContext('2d', { alpha: true });
  if (!ctx) throw new Error('canvas 2d context not available');

  const surface: Surface = {
    el: canvas,
    ctx,
    width: 0,
    height: 0,
    dpr: window.devicePixelRatio || 1,
    clear(bg: string) {
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      if (bg === 'transparent') {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      } else {
        ctx.fillStyle = bg;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }
      ctx.restore();
      ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    },
    resize(cssWidth, cssHeight) {
      this.dpr = window.devicePixelRatio || 1;
      this.width = cssWidth;
      this.height = cssHeight;
      canvas.width = Math.round(cssWidth * this.dpr);
      canvas.height = Math.round(cssHeight * this.dpr);
      canvas.style.width = `${cssWidth}px`;
      canvas.style.height = `${cssHeight}px`;
      ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    },
  };

  return surface;
}

export function resizeToFullscreen(surface: Surface, onResize?: () => void): void {
  function apply() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    if (Math.abs(w - surface.width) > 0.5 || Math.abs(h - surface.height) > 0.5) {
      surface.resize(w, h);
      onResize?.();
    }
  }
  window.addEventListener('resize', apply);
  apply();
}
